import { useQuery } from "@tanstack/react-query";
import { getTermsHistory, getTermsDetail } from "api/terms";
import { TServices, TTerms } from "types/terms/termsTypes";

export const useFetchTerms = (termsId: number) => {
  return useQuery(["getTermsDetail", termsId], () => getTermsDetail(termsId));
};

export const useFetchTermsHistory = (type: TTerms, fetchFrom: TServices) => {
  return useQuery(["getTermsHistory", type, fetchFrom], () => getTermsHistory(type, fetchFrom));
};
